import React, { useState } from 'react';

import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { changeMail } from 'api/endpoints/user';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import { MESSAGE_COMMON, MESSAGE_LOGIN } from 'constants/string/messages';
import { TEXT_COMMON, TEXT_PROFILE } from 'constants/string/texts';
import useUser from 'hooks/useUser';
import { toastError, toastSuccess } from 'lib/toast';
import { setLoading } from 'store/actions/common';
import { validateEmail, isFullWidth, validateJapanese } from 'utils/helper';

const UpdateEmail = ({ back }) => {
  const { me } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { getMe } = useUser();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [emailInValidJapan, setEmailInValidJapan] = useState(false);

  const initialValues = {
    email: me.email,
  };

  const handleChangeMail = async (values) => {
    try {
      dispatch(setLoading({ isOpen: true }));
      await changeMail({ email: values.email })
        .then(async (response) => {
          toastSuccess(response?.message || '');
          getMe();
          back();
        })
        .catch((errors) => {
          toastError(errors.message);
        });
      dispatch(setLoading({ isOpen: false }));
    } catch {
      //  Handle error
      dispatch(setLoading({ isOpen: false }));
    }
  };

  const form = useFormik({
    initialValues: initialValues,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};

      if (values.email && (isFullWidth(values.email) || validateJapanese(values.email))) {
        errors.email = true;
        setEmailInValidJapan(true);
      } else if (!values.email || !validateEmail(values.email)) {
        errors.email = true;
        setEmailInValidJapan(false);
      } else {
        setEmailInValidJapan(false);
      }

      setIsSubmitted(true);
      return errors;
    },
    onSubmit: async (values) => {
      await handleChangeMail(values);
    },
  });

  return (
    <>
      <div className="flex-between-center px-6 py-4 border-b border-white-720">
        <p className="font-bold">{TEXT_PROFILE.TITLE_EMAIL_EDITING}</p>
      </div>

      <div className="p-6">
        <fieldset>
          <p className="text-black/85 mb-2 flex items-center">
            <span className="text-danger-411 mr-1">
              <img src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
            </span>
            {TEXT_PROFILE.EMAIL_ADDRESS}
          </p>
          <Input
            id="email"
            name="email"
            type="text"
            value={form.values.email}
            onChange={form.handleChange}
            className="w-full"
            invalid={form.errors.email}
          />

          <p className="text-sm text-danger-229">
            {!form.values.email && form.errors.email && <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>}
            {form.values.email ? (
              emailInValidJapan ? (
                <ErrorMessage>{MESSAGE_LOGIN.EMAIL_INVALID_FORMAT}</ErrorMessage>
              ) : (
                form.errors.email && <ErrorMessage>{MESSAGE_LOGIN.INVALID_EMAIL}</ErrorMessage>
              )
            ) : (
              <></>
            )}
            {!form.errors.email && !emailInValidJapan && <p className={'text-sm text-secondary-354'}>{TEXT_PROFILE.REQUIRED_EMAIL_TEXT}</p>}
          </p>
        </fieldset>
      </div>

      <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
        <Button className="h-8 w-25.5 text-sm" text={TEXT_COMMON.CANCEL_TEXT} color="outline" onClick={back} />
        <Button className="h-8 w-20 text-sm" text={TEXT_COMMON.RENEW} color="primary" onClick={form.handleSubmit} />
      </div>
    </>
  );
};

export default React.memo(UpdateEmail);
